import _u from './util';
import _v from './vars';
import _m from './mappings';
import _fn from './shared-fn';
import handleTypeAhead from './type-ahead';
import SmoothScroll from 'smooth-scroll';

let touchMoveFlag = false;
let keyFlag = false;

function checkFilterChange(e) {	// Check if filters have changed on Main Page
	setTimeout(function() {
		if (_u.qS('.slry-filt-bar-main .emp-input .slry-sel-opt.selected').getAttribute('data-emp') != _v.userEmpQry) { // If Employment Status has changed
			_u.qS('.slry-filt-bar-main .slry-go').classList.add('active');	
		} else if (_u.qS('.slry-filt-bar-main .spec-input .slry-sel-opt.selected').innerText.trim() != decodeURIComponent(_u.checkQuery('specialty').replace(/\+/g,'%20'))) { // If Specialty has changed
			_u.qS('.slry-filt-bar-main .slry-go').classList.add('active');	
		} else if (_u.qS('.slry-filt-bar-main .yoe-input .slry-sel-opt.selected').getAttribute('data-yr') != decodeURIComponent(_u.checkQuery('yoe'))) { // If YOE has changed
			_u.qS('.slry-filt-bar-main .slry-go').classList.add('active');
		} else if (_v.userCity != decodeURIComponent(_u.checkQuery('city').replace(/\+/g,'%20')) || _v.userState != decodeURIComponent(_u.checkQuery('state'))) { // If Location has changed
			_u.qS('.slry-filt-bar-main .slry-go').classList.add('active');
		}
		else {
			_u.qS('.slry-filt-bar-main .slry-go').classList.remove('active');
		}
	}, 350);
}

function touchMoveHandle() {
	touchMoveFlag = true;
}

function clickAway(e) {
	setTimeout(function() {
		if (!touchMoveFlag) {
			e.stopPropagation();
			if (_u.getClosest(e.target, '.slry-input-wrap') == null) {	
				_u.qS('.slry-input-wrap').forEach((el) => {
					el.classList.remove('active');
					if (el.querySelector('.slry-sel') != null) {
						el.querySelector('.slry-sel').removeAttribute('style');
						setTimeout(function() {
							el.querySelector('.slry-sel').classList.remove('active');
						}, 150);
					}
				});	
				document.body.removeEventListener('click', clickAway);
				document.body.removeEventListener('touchstart', clickAway);
				document.body.removeEventListener('touchmove', touchMoveHandle);
				
			}
		}
		else {
			touchMoveFlag = false;
		}
	}, 150);
}

function bindKeyFlag() {
	if (_u.qS('body').classList.contains('non-touch')) {
		_u.qS('body').addEventListener('keydown', function(e) { keyFlag = true; });
		_u.qS('body').addEventListener('mousedown', function(e) { keyFlag = false; });
	}
}

function adjustMenuHeight(elem) {
	let selOptions = elem.querySelectorAll('.slry-sel-opt');	
	for (let x = 0; x < selOptions.length; x++) {
		if (selOptions[x].offsetTop >= 342) { // 342 is max menu height on all BP
			let lastVisItem = x-1;
			if (selOptions[lastVisItem].offsetTop + 12 + (selOptions[lastVisItem].offsetHeight/2) > 342) {
				lastVisItem--;
			}
			if (selOptions[lastVisItem].offsetParent == null) { // If that option is hidden, bump it back to the previous one...
				lastVisItem--;
			}			
			elem.style.maxHeight = selOptions[lastVisItem].offsetTop + 12 + (selOptions[lastVisItem].offsetHeight/2) + 'px'; // 10 is menu padding on all BP, 12 for 2px extra
			break;
		}
	}
}

function handleDropDownExpand(e) {
	
	let self = this;
	
	e.stopPropagation();
	
	if (this.classList.contains('active')) {
		if (e.type == 'click') {
			this.classList.remove('active');
			this.querySelector('.slry-sel').removeAttribute('style');
			setTimeout(function() {
				self.querySelector('.slry-sel').classList.remove('active');
			}, 150);
			
			this.focus();
			
			this.querySelectorAll('.slry-sel-opt').forEach(function(el) {
				el.removeAttribute('tabindex');
				el.classList.remove('focus');						 
			});
			
			document.body.removeEventListener('click', clickAway);
			document.body.removeEventListener('touchstart', clickAway);
			document.body.removeEventListener('touchmove', touchMoveHandle);
		}
	} else {
		 if (e.type == 'click' || e.which == 13 || e.which == 32 || e.which == 40) {
			e.preventDefault();
			if (e.type == 'keydown') {
				keyFlag = true;
			}
			_u.qS('.slry-input-wrap').forEach((el) => {
				el.classList.remove('active');
				if (el.querySelector('.slry-sel') != null && el != this) {
					el.querySelector('.slry-sel').removeAttribute('style');	
					setTimeout(function() {
						el.querySelector('.slry-sel').classList.remove('active');						
					}, 150);
				}
			});
			this.classList.add('active');
			this.querySelector('.slry-sel').scrollTop = 0;
			
			adjustMenuHeight(this.querySelector('.slry-sel'));	
			setTimeout(function() {
				self.querySelector('.slry-sel').classList.add('active');
				
				if (self.querySelector('.slry-sel').getBoundingClientRect().bottom > window.innerHeight) {
					let menuScrollOffset = self.querySelector('.slry-sel').getBoundingClientRect().bottom - window.innerHeight;					
					if (typeof breakpoint != 'undefined' && breakpoint < 3 && document.querySelector('.slry-filt-bar').classList.contains('active')) { // Modal layer visible on lower BP
						document.querySelector('.slry-filt-modal').scrollTop = document.querySelector('.slry-filt-modal').scrollTop + menuScrollOffset;
					} else if (document.querySelector('.slry-welc-abt').classList.contains('active')) {
						let menuScroll = new SmoothScroll(null, { speed: 150, easing: 'easeInOutQuad' });
						menuScroll.animateScroll(window.pageYOffset + menuScrollOffset);
					}					
				}
				
			}, 150);	
			
			document.body.addEventListener('click', clickAway);
			document.body.addEventListener('touchstart', clickAway);
			document.body.addEventListener('touchmove', touchMoveHandle);
			
			this.querySelectorAll('.slry-sel-opt').forEach(function(el) {
				el.setAttribute('tabindex','0');
			});
			
			for (let x = 0; x < this.querySelectorAll('.slry-sel-opt').length; x++) {
				if (this.querySelectorAll('.slry-sel-opt')[x].offsetParent != null) {
					this.querySelectorAll('.slry-sel-opt')[x].focus();
					if (keyFlag) {
						this.querySelectorAll('.slry-sel-opt')[x].classList.add('focus');
					}
					break;
				}
			}
			   
		}
		else if (e.which == 39) {
			e.preventDefault();
			if (e.type == 'keydown') {
				keyFlag = true;
			}
			for (let x = _u.getIndex(this) + 1; x < this.parentNode.children.length; x++) {
				if (this.parentNode.children[x].classList.contains('slry-input-wrap')) {
					if (this.parentNode.children[x].classList.contains('loc-input')) {
						this.parentNode.querySelector('.slry-input.loc-input').focus();
					} else {
						this.parentNode.children[x].focus();
					}
					break;
				}
				else if (this.parentNode.children[x].classList.contains('slry-go')) {					
					this.parentNode.children[x].focus();
					document.querySelectorAll('.focus').forEach(function(elem) {
						elem.classList.remove('focus');
					});
					this.parentNode.children[x].classList.add('focus');
				}
			}
		}
		else if (e.which == 37) {
			e.preventDefault();
			if (e.type == 'keydown') {
				keyFlag = true;
			}
			for (let x = _u.getIndex(this) - 1; x > -1; x--) {
				if (this.parentNode.children[x].classList.contains('slry-input-wrap')) {
					if (this.parentNode.children[x].classList.contains('loc-input')) {
						this.parentNode.querySelector('.slry-input.loc-input').focus();
					} else {
						this.parentNode.children[x].focus();
					}
					break;
				}
			}
		}
	}		
}

function handleListItem(e) {
	
	var self = this;
	
	e.stopPropagation();
	e.preventDefault();
	
	if (e.type == 'click' || (e.type == 'keydown' && (e.which == 13 || e.which == 32))) {
												   /*   Return 		||	Space		*/
		if (e.type == 'keydown') {
			keyFlag = true;
		}
		this.parentNode.previousElementSibling.classList.remove('default');
		this.parentNode.previousElementSibling.parentNode.classList.remove('error');
		this.parentNode.previousElementSibling.firstElementChild.innerText = this.innerText;
		this.parentNode.querySelectorAll('.slry-sel-opt.selected').forEach((el) => {					
			el.classList.remove('selected');
		});
		this.classList.add('selected');
		
		this.parentNode.parentNode.classList.remove('active');
		this.parentNode.parentNode.querySelector('.slry-sel').removeAttribute('style');
		setTimeout(function() {
			self.parentNode.parentNode.querySelector('.slry-sel').classList.remove('active');
		}, 150);
			
		this.parentNode.parentNode.focus();
			
		this.parentNode.parentNode.querySelectorAll('.slry-sel-opt').forEach(function(el) {
			el.removeAttribute('tabindex');
		});
		
		document.body.removeEventListener('click', clickAway);
		document.body.removeEventListener('touchstart', clickAway);
		document.body.removeEventListener('touchmove', touchMoveHandle);	
	}
	else if (e.type == 'keydown' && ((e.which == 9 && !e.shiftKey) || e.which == 40 || e.which == 39)) {
									/*   Tab	||		Down	 || 	Right	*/
		keyFlag = true;
		
		if (document.activeElement.classList.contains('slry-sel-opt') && !document.activeElement.classList.contains('focus')) { // clicked into dropdown
			document.activeElement.classList.add('focus');
		}
		else if (_u.getIndex(this) < this.parentNode.querySelectorAll('.slry-sel-opt').length - 1) {
			if (this.nextElementSibling.offsetParent != null) {
				this.classList.remove('focus');
				this.nextElementSibling.focus();
				this.nextElementSibling.classList.add('focus');
			} else if (this.nextElementSibling.nextElementSibling != null) {
				this.classList.remove('focus');
				this.nextElementSibling.nextElementSibling.focus();
				this.nextElementSibling.nextElementSibling.classList.add('focus');
			}
		}
		
	}
	else if (e.type == 'keydown' && (e.which == 38 || e.which == 37 || (e.which == 9 && e.shiftKey))) {
									 /* 	Up	   ||	  Left		||  Shift-Tab */
		keyFlag = true;
		
		if (_u.getIndex(this) > 0) {
			if (this.previousElementSibling.offsetParent != null) {
				this.classList.remove('focus');
				this.previousElementSibling.focus();
				this.previousElementSibling.classList.add('focus');
			} else if (this.previousElementSibling.previousElementSibling != null) {
				this.classList.remove('focus');
				this.previousElementSibling.previousElementSibling.focus();
				this.previousElementSibling.previousElementSibling.classList.add('focus');
			}
		}
		else {
			this.parentNode.parentNode.classList.remove('active');
			this.parentNode.parentNode.querySelector('.slry-sel').removeAttribute('style');
			setTimeout(function() {
				self.parentNode.parentNode.querySelector('.slry-sel').classList.remove('active');
			}, 150);
			
			this.parentNode.parentNode.focus();
			
			this.parentNode.parentNode.querySelectorAll('.slry-sel-opt').forEach(function(el) {
				el.removeAttribute('tabindex');
			});
				
			document.body.removeEventListener('click', clickAway);
			document.body.removeEventListener('touchstart', clickAway);
			document.body.removeEventListener('touchmove', touchMoveHandle);
		}
	}
}

function handleLocInput(e) {	
	keyFlag = true;
	
	if ((e.which == 8 || e.which == 46) && this.value.match(/, \w\w/) != null) {
		this.value = '';
		_v.blockTyping = false;
	}
	else if (e.which == 9 || e.which == 39 || e.which == 37) {	
		if ((e.which == 9 && !e.shiftKey) || (e.which == 39 && this.selectionStart == this.value.length)) {		
			e.stopPropagation();
			e.preventDefault();
			this.parentNode.parentNode.querySelector('.slry-input-wrap.yoe-input').focus();
		}
		else if ((e.which == 9 && e.shiftKey) || (e.which == 37 && this.selectionStart == 0)) {		
			e.stopPropagation();
			e.preventDefault();
			this.parentNode.parentNode.querySelector('.slry-input-wrap.spec-input').focus();
		}			
	}
	else if ((e.which == 13 || e.which == 40) && this.parentNode.querySelectorAll('.slry-sel-opt').length > 0) {
		
		e.stopPropagation();
		e.preventDefault();
					
		if (e.which == 13) {
		   /*   Return 	 */
		   for (let x = 0; x < this.parentNode.querySelectorAll('.slry-sel-opt').length; x++) {
			   if (this.parentNode.querySelectorAll('.slry-sel-opt')[x].offsetParent != null) {
					this.parentNode.querySelectorAll('.slry-sel-opt')[x].click();
					_v.blockTyping = true;
					break;
			   }
		   }
		}
		else if (e.which == 40) {
				/* 	 Down	*/
		   for (let x = 0; x < this.parentNode.querySelectorAll('.slry-sel-opt').length; x++) {
			   if (this.parentNode.querySelectorAll('.slry-sel-opt')[x].offsetParent != null) {
					this.parentNode.querySelectorAll('.slry-sel-opt')[x].focus();
					this.parentNode.querySelectorAll('.slry-sel-opt')[x].classList.add('focus');
					break;
			   }
		   }
		}
		
	} else if (_v.blockTyping) {
		e.preventDefault();
	}
}

function handleLocItems(e) {
	if (e.type == 'click' || e.which == 13 || e.which == 32 || e.which == 40 || e.which == 39 || e.which == 38 || e.which == 37) {
		
		if (e.type == 'keydown') {
			keyFlag = true;
		}
		
		e.stopPropagation();
		e.preventDefault();
		
		if (e.type == 'click' || (e.type == 'keydown' && (e.which == 13 || e.which == 32))) {
			let locInput = this.parentNode.previousElementSibling;
			_v.citySelected = true;
			_v.blockTyping = true;
			locInput.parentNode.classList.remove('error');
			locInput.value = this.innerHTML;
			_v.userLoc = this.innerHTML.trim();						
			_v.userCity = _v.userLoc.split(',')[0];
			_v.userDma = this.getAttribute('data-dma');
			_v.userState = this.getAttribute('data-state');
			_v.userRegion = this.getAttribute('data-region');
			locInput.parentNode.classList.remove('active');
			locInput.parentNode.querySelector('.slry-sel').innerHTML = '';
			locInput.focus();			
			if (_u.qS('.slry-welc-abt').classList.contains('active')) {
				_filt.checkWelcReq();
			} else {
				checkFilterChange();
			}
		}			
		else if (e.which == 40 || e.which == 39) {
				 /*   Down 	   || 	Right	*/
			if (_u.getIndex(this) < this.parentNode.querySelectorAll('.slry-sel-opt').length - 1) {
				if (this.nextElementSibling.offsetParent != null) {
					this.classList.remove('focus');
					this.nextElementSibling.focus();
					this.nextElementSibling.classList.add('focus');
				} else if (this.nextElementSibling.nextElementSibling != null) {
					this.classList.remove('focus');
					this.nextElementSibling.nextElementSibling.focus();
					this.nextElementSibling.nextElementSibling.classList.add('focus');
				}
			}
				
		}
		else if (e.which == 38 || e.which == 37) {
				 /* 	Up	   ||	  Left	 */
			if (_u.getIndex(this) > 0) {
				if (this.previousElementSibling.offsetParent != null) {
					this.classList.remove('focus');
					this.previousElementSibling.focus();
					this.previousElementSibling.classList.add('focus');
				} else if (this.previousElementSibling.previousElementSibling != null) {
					this.classList.remove('focus');
					this.previousElementSibling.previousElementSibling.focus();
					this.previousElementSibling.previousElementSibling.classList.add('focus');
				}
			}
			else {
				this.classList.remove('focus');
				this.parentNode.parentNode.querySelector('.slry-input.loc-input').focus();
			}
		}
	}
}

function locInputClickAway(e) {	
	if (e.type == 'blur' || (e.type == 'touchstart' && _u.getClosest(e.target, '.loc-input') == null)) {	
		document.body.removeEventListener('touchstart', locInputClickAway);
		this.parentNode.classList.remove('highlight');
		this.parentNode.classList.remove('focus');
		setTimeout(function() {
			if (!document.activeElement.classList.contains('slry-sel-opt')) {
				_u.qS('.slry-input.loc-input').forEach(function(elem) {			
			if (_v.userLoc != null) {
						elem.value = _v.userLoc;
					} else {
						elem.value = '';
					}
					elem.parentNode.classList.remove('active');
					if (elem.parentNode.querySelector('.slry-sel') != null) {
						elem.parentNode.querySelector('.slry-sel').classList.remove('active');
						elem.parentNode.querySelector('.slry-sel').innerHTML = '';
					}
				});
				if (_u.qS('.slry-welc-abt').classList.contains('active')) {
					_filt.checkWelcReq();
				} else {
					checkFilterChange();
				}
			}
		}, 50);
	}	
}

function bindDropdowns() {
	
	// Click on Dropdown Top Open/Close
	_u.qS('.slry-input-wrap.dropdown').forEach((elem) => {
		elem.addEventListener('click', handleDropDownExpand);
		elem.addEventListener('keydown', handleDropDownExpand);
	});
	
	// Click on Dropdown Menu Items
	_u.qS('.slry-sel-opt').forEach((elem) => {
		elem.addEventListener('click', handleListItem);
		elem.addEventListener('keydown', handleListItem);
	});
	
	// Add Box-shadow on Focus
	_u.qS('.slry-input-wrap').forEach((elem) => {
		elem.addEventListener('focus', (e) => {
			elem.classList.add('highlight');
			if (keyFlag) {
				document.querySelectorAll('.focus').forEach(function(elem) {
					elem.classList.remove('focus');
				});
				elem.classList.add('focus');
			}
		});
		elem.addEventListener('blur', (e) => {
			elem.classList.remove('highlight');
			elem.classList.remove('focus');
		});
	});
	
	// Add Border for Keys on Go Button
	_u.qS('.slry-go').forEach((elem) => {
		elem.addEventListener('focus', (e) => {
			if (keyFlag) {
				document.querySelectorAll('.focus').forEach(function(elem) {
					elem.classList.remove('focus');
				});
				elem.classList.add('focus');
			}
		});
		elem.addEventListener('blur', (e) => {
			elem.classList.remove('focus');
		});
	});
	
	// Location Focus / Blur
	_u.qS('.slry-input.loc-input').forEach(function(elem) {		
		elem.addEventListener('focus', function(e) {		
			this.parentNode.classList.add('highlight');
			if (keyFlag) {
				document.querySelectorAll('.focus').forEach(function(elem) {
					elem.classList.remove('focus');
				});
				this.parentNode.classList.add('focus');	
			}
			
			_u.qS('.slry-input-wrap:not(.loc-input)').forEach((el) => {
				el.classList.remove('active');
				if (el.querySelector('.slry-sel') != null) {
					el.querySelector('.slry-sel').removeAttribute('style');
					setTimeout(function() {
						el.querySelector('.slry-sel').classList.remove('active');
					}, 150);
				}
			});
			
			document.body.addEventListener('click', clickAway);
			document.body.addEventListener('touchstart', clickAway);
			document.body.addEventListener('touchmove', touchMoveHandle);			
		});
		
		elem.addEventListener('blur', locInputClickAway);
		
		elem.addEventListener('click', function(e) {
			_v.blockTyping = false;
			this.value = '';
			document.body.addEventListener('touchstart', locInputClickAway);
		});
		
	});	
	
}

function bindWelcValidate() {
	// Bind form elements to validation-function
	_u.qS('.slry-welc .slry-input.loc-input').addEventListener('keyup', handleTypeAhead);	
	_u.qS('.slry-welc .slry-input.loc-input').addEventListener('keydown', handleLocInput);
	
	document.addEventListener('locsReady', () => {
		document.querySelectorAll('.slry-welc .loc-input .slry-sel-opt').forEach(function(elem) {
			elem.addEventListener('keydown', handleLocItems);
			elem.addEventListener('click', handleLocItems);
		});
	});
	
	_u.qS('.slry-welc .slry-sel-opt').forEach((elem) => {
		elem.addEventListener('click', _filt.checkWelcReq);
		elem.addEventListener('keydown', _filt.checkWelcReq);
		elem.addEventListener('keyup', _filt.checkWelcReq);
	});
	
	_u.qS('.slry-welc .slry-go').addEventListener('click', _filt.handleSubmit);
	_u.qS('.slry-welc .slry-go').addEventListener('keydown', _filt.handleSubmit);
}

function bindAboutMore() {
	// Bind 'About' section View More link
	_u.qS('.slry-left-col .slry-abt-more').addEventListener('click', function() {
		_u.qS('.slry-left-col .slry-abt').classList.add('expanding');
		setTimeout(function() {
			_u.qS('.slry-left-col .slry-abt').classList.remove('expanding');
			document.dispatchEvent(new CustomEvent('heightChange'));
		}, 340);
		_u.qS('.slry-left-col .slry-abt').classList.toggle('expanded');
		if (_u.qS('.slry-left-col .slry-abt').classList.contains('expanded')) {
			_u.wmdPageLink('mse-about_more', this);
		} else {
			_u.wmdPageLink('mse-about_less', this);
		}
	});
}

function bindWelcome() {

	// Fade + scroll welcome widget on DOM-ready
	window.addEventListener('DOMContentLoaded', (event) => {
		_u.qS('.slry-welc').classList.add('active');
	});
	
	// Add 'selected' class for specialty, for signed in users
	if (_u.qS('.slry-welc .spec-input .slry-sel-opt.selected') == null) {
		_u.qS('.slry-welc .spec-input .slry-sel-opt').forEach((elem) => {
			elem.classList.remove('selected');
		});
		_u.qS('.slry-welc .spec-input .slry-sel-opt').forEach((elem) => {
			if (elem.innerHTML.trim() == _u.qS('.slry-welc .spec-input .slry-input-label').innerHTML.trim()) {
				elem.classList.add('selected');
			}
		});
	}
	
	bindWelcValidate();
	bindAboutMore();
	
}

// Exportable Object/Functions
let _filt = {

	'checkWelcReq': function() { // Check if all required selections made on Welcome
		setTimeout(function() {
			if (_v.citySelected && document.querySelectorAll('.slry-welc .slry-input.default').length == 0) {
				_u.qS('.slry-welc .slry-go').classList.add('active');
			} else {
				_u.qS('.slry-welc .slry-go').classList.remove('active');
			}
		}, 350)
	},

	'bindSticky': function() {
		window.addEventListener('scroll', () => {
			let stickyAtStart = _u.qS('.slry-body').classList.contains('sticky');
			if (window.pageYOffset >= _u.qS('#headerbox').offsetHeight + _u.qS('.slry-main').offsetTop) {
				_u.qS('.slry-filt-bar').classList.add('sticky');
				_u.qS('.slry-body').classList.add('sticky');
			} else {
				_u.qS('.slry-filt-bar').classList.remove('sticky');	
				_u.qS('.slry-body').classList.remove('sticky');
			}
			if (document.body.classList.contains('is-ie')) {			
				if ((!stickyAtStart && _u.qS('.slry-body').classList.contains('sticky')) || (stickyAtStart && !_u.qS('.slry-body').classList.contains('sticky'))) {
					document.dispatchEvent(new CustomEvent('heightChange'));
				}
			}
		});
	},

	'bindFilters': function() {	
		
		bindKeyFlag();
		bindDropdowns();
		bindWelcome();
		
		// Filter input validation
		_u.qS('.slry-filt-bar-main .slry-sel-opt').forEach((elem) => {
			elem.addEventListener('click', checkFilterChange);
			elem.addEventListener('keydown', checkFilterChange);
			elem.addEventListener('keyup', checkFilterChange);
		});
		
		_u.qS('.slry-filt-bar-main .slry-input.loc-input').addEventListener('keyup', handleTypeAhead);
		
		_u.qS('.slry-filt-bar-main .slry-input.loc-input').addEventListener('keydown', handleLocInput);		
		document.addEventListener('locsReady', () => {			
			document.querySelectorAll('.slry-filt-bar-main .loc-input .slry-sel-opt').forEach(function(elem) {
				elem.addEventListener('keydown', handleLocItems);
				elem.addEventListener('click', handleLocItems);
			});
		});		

		// Mobile filter bindings
		_u.qS('.slry-filt-bar-links').addEventListener('click', function(e) {
			_u.qS('.slry-filt-bar').classList.add('active');
			_u.qS('body').classList.add('filter');
		});
		_u.qS('.slry-filt-bar-links').addEventListener('keydown', function(e) {
			if (e.which == 13 || e.which == 32) {
				e.preventDefault();
				_u.qS('.slry-filt-bar').classList.add('active');
				_u.qS('body').classList.add('filter');
				_u.qS('.slry-filt-bar-main .slry-input-wrap.spec-input').focus();
			}
		});
		_u.qS('.slry-filt-bar-main-close').addEventListener('click', function(e) {
			_u.qS('.slry-filt-bar').classList.remove('active');
			_u.qS('body').classList.remove('filter');
		});
		_u.qS('.slry-filt-bar-main-close').addEventListener('keydown', function(e) {
			if (e.which == 13 || e.which == 32) {
				e.preventDefault();
				_u.qS('.slry-filt-bar').classList.remove('active');
				_u.qS('body').classList.remove('filter');
			}
		});

		// Filter submission
		_u.qS('.slry-filt-bar-main .slry-go').addEventListener('click', _filt.handleSubmit);
		_u.qS('.slry-filt-bar-main .slry-go').addEventListener('keydown', _filt.handleSubmit);
	},
	
	'handleSubmit': function(e) {
		
		if (typeof e != 'undefined' && e.type == 'keydown') {
			keyFlag = true;
		}
		
		if (!(typeof e != 'undefined' && e.type == 'keydown' && e.which != 13 && e.which != 32)) { // If keydown but its not Enter/Space, then ignore
			// Add Welcome screen error-messaging, if necessary
			if (typeof this.classList != 'undefined' && !this.classList.contains('active') && typeof e != 'undefined' && e.target != window && e.target.parentNode.classList.contains('slry-welc')) {	
				if (!_v.citySelected) {
					_u.qS('.slry-welc .slry-input.loc-input').parentNode.classList.add('error');
				}
				document.querySelectorAll('.slry-welc .slry-input.default').forEach((el) => {
					el.parentNode.classList.add('error');
				});
			} else if (typeof this.classList != 'undefined' && this.classList.contains('active') || typeof this.classList == 'undefined') {
				
				let inputSel = '.slry-filt-bar-main ';
				if (typeof e != 'undefined' && e.target != window && e.target.parentNode.classList.contains('slry-welc')) {
					inputSel = '.slry-welc ';
				}
				
				// Set vars from user input
				_v.homePageId = _u.qS(inputSel + '.spec-input .slry-sel-opt.selected').getAttribute('data-id');
				_v.userLoc = _u.qS(inputSel + '.slry-input.loc-input').value.trim();		
				_v.userCity = _v.userLoc.split(',')[0];
				_v.userYoe = _u.qS(inputSel + '.yoe-input .slry-sel-opt.selected').innerText.trim();
				_v.userYoeRng = _u.qS(inputSel + '.yoe-input .slry-sel-opt.selected').getAttribute('data-yr');
				_v.userYoeIdx = _u.getIndex(_u.qS(inputSel + '.yoe-input .slry-sel-opt.selected'));
				
				_v.userEmp = _u.qS('.slry-filt-bar-main .emp-input .slry-input-label').innerHTML.trim();
				_v.userEmpIdx = _u.qS('.slry-filt-bar-main .emp-input .slry-sel-opt.selected').getAttribute('data-emp');
				_v.userEmpQry = _u.qS('.slry-filt-bar-main .emp-input .slry-sel-opt.selected').getAttribute('data-emp');
					
				// Sync Specialty Input Labels
				_u.qS('.slry-filt-bar .spec-input .slry-input-label').forEach((elem) => {
					elem.innerHTML = _u.qS(inputSel + '.spec-input .slry-input-label').innerHTML;
				});			
				// Sync Specialty Selected Filter Options
				_u.qS('.slry-filt-bar .spec-input .slry-sel-opt').forEach((elem) => {
					elem.classList.remove('selected');
				});
				_u.qS('.slry-filt-bar .spec-input .slry-sel-opt').forEach((elem) => {
					if (elem.innerHTML.trim() == _u.qS('.slry-filt-bar-main .spec-input .slry-input-label').innerHTML.trim()) {
						elem.classList.add('selected');
					}
				});
				
				// Sync YOE Input Labels
				_u.qS('.slry-filt-bar .yoe-input .slry-input-label').forEach((elem) => {
					elem.innerHTML = _u.qS(inputSel + '.yoe-input .slry-input-label').innerHTML;
				});	
				// Sync YOE Selected Filter Options
				_u.qS('.slry-filt-bar .yoe-input .slry-sel-opt').forEach((elem) => {
					elem.classList.remove('selected');
				});
				_u.qS('.slry-filt-bar .yoe-input .slry-sel-opt').forEach((elem) => {
					if (elem.innerHTML.trim() == _u.qS('.slry-filt-bar-main .yoe-input .slry-input-label').innerHTML.trim()) {
						elem.classList.add('selected');
					}
				});
				
				// Sync Location Labels
				_u.qS('.slry-filt-bar-main .slry-input.loc-input').value = _u.qS(inputSel + '.slry-input.loc-input').value;
				_u.qS('.slry-filt-bar-links .slry-input.loc-input .slry-input-label').innerHTML = _u.qS(inputSel + '.slry-input.loc-input').value;
				
				// Sync Practice Setting Labels
				_u.qS('.slry-filt-bar-links .emp-input .slry-input-label').innerHTML = _v.userEmp;
				
				if ((typeof e != 'undefined' && e.target != window && e.target.parentNode.classList.contains('slry-welc')) || typeof e == 'undefined') { // Populate labels for top widget only on first time
					_fn.getLabels(_u.qS('.slry-avg-like-you'), 1);
				}
				
				// Reset Button State
				if (typeof this.classList != 'undefined') {
					this.classList.remove('active');
				}
				
				// Reset Mobile Filters
				_u.qS('.slry-filt-bar').classList.remove('active');
				_u.qS('body').classList.remove('filter');
					
				// Scroll to Top
				// window.scrollTo(0, 0);
				
				// If on Welcome, show Main Page
				if (typeof e != 'undefined' && e.target != window && e.target.parentNode.classList.contains('slry-welc')) {				
					_u.qS('.slry-section').forEach((el) => {
						el.classList.remove('active');
					});
					_u.qS('.slry-main').classList.add('active');
					_u.qS('.slry-body').classList.add('main');
					
					window.scrollTo(0, 0);				
				}
				
				// Load Salary Widgets
				if (typeof this.classList != 'undefined') {
					document.dispatchEvent(new CustomEvent('loadSalaryPage', {'detail': this}));
				} else if (typeof e != 'undefined') {
					document.dispatchEvent(new CustomEvent('loadSalaryPage', {'detail': e}));
				} else {				
					document.dispatchEvent(new CustomEvent('loadSalaryPage'));		
				}
				
			}
		} else if (e.type == 'keydown' && e.which == 37) {			
			e.preventDefault();
			for (let x = _u.getIndex(this) - 1; x > -1; x--) {
				if (this.parentNode.children[x].classList.contains('slry-input-wrap')) {
					this.parentNode.children[x].focus();
					break;
				}
			}
		}
	}
}

export default _filt;